import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import './App.css';

const resources = [
  {
    logo: '/images/google-logo.png',
    title: "Google's Veteran Network (VetNet)",
    description: "Explore career opportunities, get application tips, and connect with the vibrant community of veteran employees at Google.",
    link: "https://www.google.com/about/careers/applications/stories/vetnet/",
    tag: "#Career_Opportunities"
  },
  {
    logo: '/images/amazon-logo.png',
    title: "Amazon's Military Hiring",
    description: "Amazon is committed to hiring and supporting military talent. Discover programs and open roles for veterans and military spouses.",
    link: "https://hiring.amazon.com/our-team/military#/",
    tag: "#Career_Opportunities"
  },
  {
    logo: '/images/blue-origin-logo.png',
    title: "Blue Origin's Veteran Community",
    description: "Join a team of pioneers and veterans building the future of spaceflight. Explore careers in engineering, manufacturing, and more.",
    link: "https://www.blueorigin.com/diversity",
    tag: "#Community"
  },
  {
    logo: '/images/microsoft-logo.png',
    title: "Microsoft Military Affairs",
    description: "Microsoft offers industry-leading training programs, apprenticeships, and career opportunities for the military community.",
    link: "https://military.microsoft.com/",
    tag: "#Upskilling"
  },
  {
    logo: '/images/boeing-logo.png',
    title: "Boeing's Veteran Careers",
    description: "Bring your skills to a company that values your service and offers a mission-driven career in aerospace and defense.",
    link: "https://jobs.boeing.com/veterans",
    tag: "#Career_Opportunities"
  },
  {
    logo: '/images/anduril-logo.png',
    title: "Anduril Industries Careers",
    description: "Join a fast-growing defense technology company building the future of military capabilities with a team of top-tier talent.",
    link: "https://www.anduril.com/careers",
    tag: "#Career_Opportunities"
  },
  {
    logo: '/images/ge-logo.png',
    title: "GE's Veteran Network",
    description: "General Electric offers a wide range of roles for veterans in energy, aviation, and healthcare technology.",
    link: "https://ge.veteran-hiring.com/?v=17534913086884276c624d01753491309708",
    tag: "#Career_Opportunities"
  },
  {
    logo: '/images/ge-aerospace-logo.png',
    title: "GE Aerospace Veteran Careers",
    description: "Build the future of flight with a world-leading aerospace company that actively recruits and supports military veterans.",
    link: "https://careers.geaerospace.com/global/en/aviation-veterans-us",
    tag: "#Career_Opportunities"
  },
  {
    logo: '/images/lockheed-martin-logo.png',
    title: "Lockheed Martin Military Support",
    description: "Your mission continues here. Lockheed Martin is a top employer of veterans, offering impactful careers in defense and technology.",
    link: "https://www.lockheedmartin.com/en-us/who-we-are/communities/military-veteran-support.html",
    tag: "#Community"
  },
  {
    logo: '/images/kaiser-permanente-logo.png',
    title: "Kaiser Permanente Military Careers",
    description: "Find a rewarding career in healthcare with a nationally recognized leader in supporting veteran and military spouse employment.",
    link: "https://www.kaiserpermanentejobs.org/military",
    tag: "#Career_Opportunities"
  },
  {
    logo: '/images/rtx-logo.png',
    title: "Raytheon Technologies (RTX) Military & Veterans",
    description: "Explore career opportunities and resources for veterans at RTX, a leader in aerospace and defense.",
    link: "https://careers.rtx.com/global/en/militaryandveterans",
    tag: "#Career_Opportunities"
  },
  {
    logo: '/images/home-depot-logo.png',
    title: "The Home Depot Veteran Programs",
    description: "The Home Depot is committed to supporting veterans through employment, community involvement, and associate-led programs.",
    link: "https://corporate.homedepot.com/page/serving-veterans",
    tag: "#Community"
  }
];

function Resources() {
  return (
    <Container className="my-5">
      <div className="text-center mb-5">
        <h1 className="app-title">Resources & Waypoints</h1>
        <p className="app-tagline">A chart of organizations providing valuable support, community, and career opportunities for your transition.</p>
      </div>
      <Row>
        {resources.map((resource, index) => (
          <Col key={index} md={6} lg={4} className="mb-4">
            <Card className="h-100 shadow-sm card-coastal">
              <Card.Body className="d-flex flex-column">
                <div className="text-center mb-3">
                  <img src={resource.logo} alt={`${resource.title} logo`} style={{ maxWidth: '150px', maxHeight: '50px' }} />
                </div>
                <Card.Title className="text-center">{resource.title}</Card.Title>
                <Card.Text className="flex-grow-1">{resource.description}</Card.Text>
                <Button href={resource.link} target="_blank" variant="primary" className="btn-primary-custom mt-auto">Visit Site</Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="justify-content-center">
        <Col md={8} className="text-center">
          <div className="text-center mt-5 pt-3 border-top">
            <h5 className="text-muted">Rules of Engagement</h5>
            <p className="text-muted small">
              The organizations listed here are independent commands. We provide these links as potential waypoints on your journey. ComRelAI is not responsible for the content or operations of these third-party sites. Your interaction with them is at your own discretion.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Resources;
